import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { loadErrorKey, useHouseSummary } from '../api';
import { Icon } from '../components/Icon';
import { Stat } from '../components/Parts';
import { count } from '../format';

export function Dashboard() {
  const { t } = useTranslation();
  const summary = useHouseSummary({});
  const s = summary.data;
  const v = (n: number | undefined) => (s ? count(n ?? 0) : '…');
  return (
    <>
      <div className="greet">
        <div>
          <h2>{t('dash.greeting')}</h2>
          <p>{t('dash.subtitle')}</p>
        </div>
        <Link className="gbtn" to="/register/members">
          <Icon name="users" />
          {t('dash.openRegister')}
        </Link>
      </div>
      {summary.isError ? <div className="callout" role="alert">{t(loadErrorKey(summary.error))}</div> : null}
      <div className="strip">
        <Stat icon="home" tone="brand" value={v(s?.houses)} label={t('dash.houses')} />
        <Stat icon="users" tone="teal" value={v(s?.members)} label={t('dash.members')} />
        <Stat icon="plane" tone="violet" value={v(s?.pravasi)} label={t('dash.pravasiHouses')} />
        <Stat icon="wallet" tone={s && s.arrears > 0 ? 'warn' : 'brand'} value={v(s?.arrears)} label={t('dash.arrearsHouses')} />
      </div>
    </>
  );
}
